import { useState } from "react";
import { Box, Grid, Typography } from "@mui/material";
import ByzMuiButton from "src/components/core-components/mui/buttons/ByzMuiButton";
import { useTranslation } from "react-i18next";

const PatientInfoTab = ({ isEditable }: { isEditable: boolean }) => {
    const [activeSection, setActiveSection] = useState<string | null>(null);
    const { t } = useTranslation();

    const sections = [
        t("surgery-pre-post-preparation.allergies"),
        t("surgery-pre-post-preparation.habits"),
        t("surgery-pre-post-preparation.family-history"),
        t("surgery-pre-post-preparation.past-illnesses"),
        t("surgery-pre-post-preparation.diseases"),
        t("surgery-pre-post-preparation.past-surgeries"),
        t("surgery-pre-post-preparation.special-notes"),
        t("surgery-pre-post-preparation.rare-diseases"),
        t("surgery-pre-post-preparation.blood-pressure-monitoring"),
        t("surgery-pre-post-preparation.exposures"),
        t("surgery-pre-post-preparation.current-medications"),
    ];

    return (
        <Box>
            {/* Bölüm Başlığı */}
            <Box sx={{
                background: "#EBF5FF",
                px: 2,
                py: 1,
                borderBottom: "1px solid #e0e0e0",
                borderRadius: 2,
                mb: 2
            }}>
                <Typography variant="h6" sx={{ color: "#2196F3" }}>{t("surgery-pre-post-preparation.patient-info-title")}</Typography>
            </Box>

            <Grid container spacing={2}>
                {/* Sol Taraf: Butonlar */}
                <Grid item xs={12} md={3}>
                    <Box sx={{ border: "1px solid #e0e0e0", borderRadius: 2, p: 2 }}>
                        {sections.map((section) => (
                            <ByzMuiButton
                                key={section}
                                sx={{ mb: 1, width: "100%" }}
                                variant={activeSection === section ? "contained" : "outlined"}
                                onClick={() => setActiveSection(section)}
                            >
                                {section}
                            </ByzMuiButton>
                        ))}
                    </Box>
                </Grid>

                {/* Sağ Taraf: İçerik Alanı */}
                <Grid item xs={12} md={9}>
                    <Box sx={{ border: "1px solid #e0e0e0", borderRadius: 2, p: 2, minHeight: "300px" }}>
                        {activeSection ? (
                            <Typography variant="h6">{sections} {t("surgery-pre-post-preparation.content-will-be-here")}</Typography>
                        ) : (
                            <Typography variant="h6">{t("surgery-pre-post-preparation.please-select-section")}</Typography>
                        )}
                    </Box>
                </Grid>
            </Grid>
        </Box>
    );
};

export default PatientInfoTab; 